module.exports = __webpack_public_path__ + "img/yingzheng.d51c4152.png";